const LOCAL_ONLY = [
  // { id: 1, type: "Local Field", messageKey: "Local Field" },
  { id: 2, type: "Related Field", messageKey: "EXP_RELATED_FIELD" }
];
const STRING = [
  // { id: 1, type: "Static", messageKey: "Hardcoded String" },
  // { id: 2, type: "Local Field", messageKey: "Local Field" },
  // { id: 3, type: "Singleton Field", messageKey: "Singleton Field" },
  {
    id: 4,
    type: "Format Date",
    messageKey: "EXP_FORMAT_DATE",
    components: "FORMAT_DATE_COMPONENTS"
  },
  {
    id: 5,
    type: "Concat",
    messageKey: "EXP_CONCAT",
    components: "CONCAT_COMPONENTS"
  },
  {
    id: 6,
    type: "Pick One",
    messageKey: "EXP_PICK_ONE",
    components: "PICK_ONE_COMPONENTS"
  },
  { id: 7, type: "Max", messageKey: "EXP_MAX", components: "MAX_COMPONENTS" },
  { id: 8, type: "Min", messageKey: "EXP_MIN", components: "MIN_COMPONENTS" },
  {
    id: 9,
    type: "Number to String",
    messageKey: "EXP_NUMBER_TO_STRING",
    components: "NUMBER_TO_STRING_COMPONENTS"
  },
  { id: 10, type: "If", messageKey: "EXP_IF", components: "IF_COMPONENTS" }
];
const NUMBER = [
  // { id: 1, type: "Static", messageKey: "Hardcoded Number" },
  // { id: 2, type: "Local Field", messageKey: "Local Field" },
  // { id: 3, type: "Singleton Field", messageKey: "Singleton Field" },
  {
    id: 4,
    type: "Count Unique",
    messageKey: "EXP_COUNT_UNIQUE",
    components: "COUNT_UNIQUE_COMPONENTS"
  },
  { id: 5, type: "Sum", messageKey: "EXP_SUM", components: "SUM_COMPONENTS" },
  {
    id: 6,
    type: "Product",
    messageKey: "EXP_PRODUCT",
    components: "PRODUCT_COMPONENTS"
  },
  {
    id: 7,
    type: "Add Number",
    messageKey: "EXP_ADD_NUM",
    components: "MATH_ADDITION_COMPONENTS"
  },
  {
    id: 8,
    type: "Subtract Number",
    messageKey: "EXP_SUBTRACT_NUM",
    components: "MATH_SUBTRACTION_COMPONENTS"
  },
  {
    id: 9,
    type: "Multiply Number",
    messageKey: "EXP_MULTIPLY_NUM",
    components: "MATH_MULTIPLICATION_COMPONENTS"
  },
  {
    id: 10,
    type: "Divide Number",
    messageKey: "EXP_DIVIDE_NUM",
    components: "MATH_DIVISION_COMPONENTS"
  },
  {
    id: 11,
    type: "Round Number",
    messageKey: "EXP_ROUND_NUM",
    components: "ROUND_COMPONENTS"
  },
  {
    id: 12,
    type: "Date Year",
    messageKey: "EXP_DATE_YEAR",
    components: "DATE_YEAR_COMPONENTS"
  },
  {
    id: 13,
    type: "Date Month",
    messageKey: "EXP_DATE_MONTH",
    components: "DATE_MONTH_COMPONENTS"
  },
  {
    id: 14,
    type: "Date Day in Month",
    messageKey: "EXP_DATE_DAY_IN_MONTH",
    components: "DATE_DAY_IN_MONTH_COMPONENTS"
  },
  {
    id: 15,
    type: "Pick One",
    messageKey: "EXP_PICK_ONE",
    components: "PICK_ONE_COMPONENTS"
  },
  { id: 16, type: "Max", messageKey: "EXP_MAX", components: "MAX_COMPONENTS" },
  { id: 17, type: "Min", messageKey: "EXP_MIN", components: "MIN_COMPONENTS" },
  { id: 18, type: "If", messageKey: "EXP_IF", components: "IF_COMPONENTS" }
];
const DATE = [
  // { id: 1, type: "Static", messageKey: "Hardcoded Date" },
  // { id: 2, type: "Local Field", messageKey: "Local Field" },
  // { id: 3, type: "Singleton Field", messageKey: "Singleton Field" },
  {
    id: 4,
    type: "Pick One",
    messageKey: "EXP_PICK_ONE",
    components: "PICK_ONE_COMPONENTS"
  },
  { id: 5, type: "Max", messageKey: "EXP_MAX", components: "MAX_COMPONENTS" },
  { id: 6, type: "Min", messageKey: "EXP_MIN", components: "MIN_COMPONENTS" },
  {
    id: 7,
    type: "Date Floor",
    messageKey: "EXP_FLOOR_DATE",
    components: "DATE_FLOOR_COMPONENTS"
  },
  {
    id: 8,
    type: "Date Ceiling",
    messageKey: "EXP_CEILING_DATE",
    components: "DATE_CEILING_COMPONENTS"
  },
  {
    id: 9,
    type: "Date Addition",
    messageKey: "EXP_ADDITION_DATE",
    components: "DATE_ADDITION_COMPONENTS"
  },
  {
    id: 10,
    type: "Date Subtraction",
    messageKey: "EXP_SUBTRACTION_DATE",
    components: "DATE_SUBTRACTION_COMPONENTS"
  },
  { id: 11, type: "If", messageKey: "EXP_IF", components: "IF_COMPONENTS" }
];
const BOOL = [
  // { id: 1, type: "Static", messageKey: "Hardcoded Boolean" },
  // { id: 2, type: "Local Field", messageKey: "Local Field" },
  // { id: 3, type: "Singleton Field", messageKey: "Singleton Field" },
  {
    id: 4,
    type: "Pick One",
    messageKey: "EXP_PICK_ONE",
    components: "PICK_ONE_COMPONENTS"
  },
  { id: 5, type: "Not", messageKey: "EXP_NOT", components: "NOT_COMPONENTS" },
  {
    id: 6,
    type: "Equal",
    messageKey: "EXP_EQUAL",
    components: "EQUAL_COMPONENTS"
  },
  {
    id: 7,
    type: "Not Equal",
    messageKey: "EXP_NOT_EQUAL",
    components: "NOT_EQUAL_COMPONENTS"
  },
  { id: 8, type: "LT", messageKey: "EXP_LT", components: "LT_COMPONENTS" },
  { id: 9, type: "LTE", messageKey: "EXP_LTE", components: "LTE_COMPONENTS" },
  { id: 10, type: "GT", messageKey: "EXP_GT", components: "GT_COMPONENTS" },
  { id: 11, type: "GTE", messageKey: "EXP_GTE", components: "GTE_COMPONENTS" },
  { id: 12, type: "In", messageKey: "EXP_IN", components: "IN_COMPONENTS" },
  {
    id: 13,
    type: "Not In",
    messageKey: "EXP_NOT_IN",
    components: "NOT_IN_COMPONENTS"
  },
  { id: 14, type: "All", messageKey: "EXP_ALL", dataType: "bool" },
  { id: 15, type: "Any", messageKey: "EXP_ANY", dataType: "bool" },
  { id: 16, type: "If", messageKey: "EXP_IF", components: "IF_COMPONENTS" }
];
const COMMON_LIST = [
  { id: 1, type: "If", messageKey: "EXP_IF", components: "IF_COMPONENTS" },
  {
    id: 2,
    type: "Field in List",
    messageKey: "EXP_FIELD_IN_LIST",
    components: "FIELD_IN_LIST_COMPONENTS"
  },
  {
    id: 3,
    type: "List of Expressions",
    messageKey: "EXP_LIST_OF_EXPRESSIONS",
    components: "LIST_OF_EXPRESSIONS_COMPONENTS"
  },
  {
    id: 4,
    type: "Related Field",
    messageKey: "EXP_RELATED_FIELD",
    components: "RELATED_FIELD_COMPONENTS"
  }
];

const STRING_LIST_LIST = [
  {
    id: 5,
    type: "Challenge Reasons",
    messageKey: "challengeReasons",
    components: "CHALLENGE_REASONS_COMPONENTS"
  },
  {
    id: 6,
    type: "Target Challenge Reasons",
    messageKey: "targetChallengeReasons",
    components: "TARGET_CHALLENGE_REASONS_COMPONENTS"
  }
];
const STRING_LIST = COMMON_LIST.concat(STRING_LIST_LIST);
const NUMBER_LIST = COMMON_LIST;
const DATE_LIST = COMMON_LIST;
const BOOL_LIST = COMMON_LIST;

const ALL_COMPARABLE_LIST = {
  STRING: true,
  NUMBER: true,
  DATE: true,
  BOOL: true
};
const COMPARABLE_LIST = {
  STRING: true,
  NUMBER: true,
  DATE: true
};

const EXPRESSIONS_TYPE = {
  LOCAL_ONLY,
  STRING,
  NUMBER,
  DATE,
  BOOL,
  STRING_LIST,
  NUMBER_LIST,
  DATE_LIST,
  BOOL_LIST
};

const LIST_COMPONENTS = {
  ALL_COMPARABLE_COMPONENTS: {
    //NOTE: This is not an expression but is used to manage comparable all expressions and boolean expressions
    type: "All Comparable",
    dataType: "", // Empty to indicate to get dataType from the component.getFieldDataType() which is field datatype
    subExpression: COMMON_LIST,
    comparables: ALL_COMPARABLE_LIST, // include boolean too
    components: "ALL_COMPARABLE_COMPONENTS"
  },
  EXP_FIELD_IN_LIST: {
    messageKey: "EXP_FIELD_IN_LIST",
    type: "Field in List",
    dataType: "", // Empty to indicate to get dataType from the component.getFieldDataType() which is field datatype
    components: "FIELD_IN_LIST_COMPONENTS"
  },
  EXP_IF: {
    messageKey: "EXP_IF",
    type: "If",
    dataType: "", // Empty to indicate to get dataType from the component.getFieldDataType() which is field datatype
    comparables: ALL_COMPARABLE_LIST, // include boolean too
    components: "IF_COMPONENTS"
  },
  EXP_NOT_IN: {
    messageKey: "EXP_NOT_IN",
    type: "Not in",
    dataType: "Bool",
    components: "NOT_IN_COMPONENTS"
  },
  EXP_IN: {
    messageKey: "EXP_IN",
    type: "In",
    dataType: "Bool",
    components: "IN_COMPONENTS"
  },
  EXP_NOT: {
    messageKey: "EXP_NOT",
    type: "Not",
    dataType: "Bool",
    components: "NOT_COMPONENTS"
  },
  EXP_GTE: {
    messageKey: "EXP_GTE",
    type: "GTE",
    dataType: "Bool",
    comparables: COMPARABLE_LIST, // don't include boolean
    components: "GTE_COMPONENTS"
  },
  EXP_GT: {
    messageKey: "EXP_GT",
    type: "GT",
    dataType: "Bool",
    comparables: COMPARABLE_LIST, // don't include boolean
    components: "GT_COMPONENTS"
  },
  EXP_LT: {
    messageKey: "EXP_LT",
    type: "LT",
    dataType: "Bool",
    comparables: COMPARABLE_LIST, // don't include boolean
    components: "LT_COMPONENTS"
  },
  EXP_LTE: {
    messageKey: "EXP_LTE",
    type: "LTE",
    dataType: "Bool",
    comparables: COMPARABLE_LIST, // don't include boolean
    components: "LTE_COMPONENTS"
  },
  EXP_NOT_EQUAL: {
    messageKey: "EXP_NOT_EQUAL",
    type: "Not Equal",
    dataType: "Bool",
    comparables: ALL_COMPARABLE_LIST, // include boolean too
    components: "NOT_EQUAL_COMPONENTS"
  },
  EXP_EQUAL: {
    messageKey: "EXP_EQUAL",
    type: "Equal",
    dataType: "Bool",
    comparables: ALL_COMPARABLE_LIST, // include boolean too
    components: "EQUAL_COMPONENTS"
  },
  EXP_RELATED_FIELD: {
    messageKey: "EXP_RELATED_FIELD",
    type: "Related Field",
    dataType: "", // Empty to indicate to get dataType from the component.getFieldDataType() which is field datatype
    components: "RELATED_FIELD_COMPONENTS"
  },
  EXP_MAX: {
    messageKey: "EXP_MAX",
    type: "Max",
    dataType: "", // Empty to indicate to get dataType from the component.getFieldDataType() which is field datatype
    subExpression: COMMON_LIST,

    comparables: COMPARABLE_LIST, // don't include boolean
    components: "MAX_COMPONENTS"
  },
  EXP_MIN: {
    messageKey: "EXP_MIN",
    type: "Min",
    dataType: "", // Empty to indicate to get dataType from the component.getFieldDataType() which is field datatype
    subExpression: COMMON_LIST,
    comparables: COMPARABLE_LIST, // don't include boolean
    components: "MIN_COMPONENTS"
  },
  EXP_LIST_OF_EXPRESSIONS: {
    messageKey: "EXP_LIST_OF_EXPRESSIONS",
    type: "List of Expressions",
    dataType: "", // Empty to indicate to get dataType from the component.getFieldDataType() which is field datatype
    subExpression: ALL_COMPARABLE_LIST,
    components: "LIST_OF_EXPRESSIONS_COMPONENTS"
  },
  EXP_DATE_MONTH: {
    label: "Date Month",
    messageKey: "EXP_DATE_MONTH",
    type: "Date Month",
    dataType: "Number",
    subExpression: NUMBER_LIST,
    comparables: ALL_COMPARABLE_LIST,
    components: "DATE_MONTH_COMPONENTS"
  },
  EXP_DATE_YEAR: {
    label: "Date Year",
    messageKey: "EXP_DATE_YEAR",
    type: "Date Year",
    dataType: "Number",
    comparables: ALL_COMPARABLE_LIST,
    components: "DATE_YEAR_COMPONENTS"
  },
  EXP_DATE_DAY_IN_MONTH: {
    label: "Date Day In Month",
    messageKey: "EXP_DATE_DAY_IN_MONTH",
    type: "Date Day In Month",
    dataType: "Number",
    comparables: ALL_COMPARABLE_LIST,
    components: "DATE_DAY_IN_MONTH_COMPONENTS"
  },
  EXP_CONCAT: {
    label: "Concat",
    messageKey: "EXP_CONCAT",
    type: "Concat",
    dataType: "String",
    subExpression: STRING_LIST,
    comparables: ALL_COMPARABLE_LIST,
    components: "CONCAT_COMPONENTS"
  },
  EXP_PICK_ONE: {
    label: "Pick One",
    messageKey: "EXP_PICK_ONE",
    type: "Pick One",
    dataType: "",
    comparables: ALL_COMPARABLE_LIST,
    subExpression: STRING_LIST,
    components: "PICK_ONE_COMPONENTS"
  },
  EXP_FORMAT_DATE: {
    label: "Format Date",
    messageKey: "EXP_FORMAT_DATE",
    type: "Format Date",
    dataType: "String",
    subExpression: STRING_LIST,
    comparables: ALL_COMPARABLE_LIST,
    components: "FORMAT_DATE_COMPONENTS"
  },
  EXP_NUMBER_TO_STRING: {
    label: "Number to String",
    messageKey: "EXP_NUMBER_TO_STRING",
    type: "Number to String",
    dataType: "String",
    subExpression: STRING_LIST,
    comparables: ALL_COMPARABLE_LIST,
    components: "NUMBER_TO_STRING_COMPONENTS"
  },
  EXP_CEILING_DATE: {
    messageKey: "EXP_CEILING_DATE",
    type: "Date Ceiling",
    dataType: "Date",
    subExpression: DATE,
    components: "DATE_CEILING_COMPONENTS"
  },
  EXP_FLOOR_DATE: {
    messageKey: "EXP_FLOOR_DATE",
    type: "Date Floor",
    dataType: "Date",
    subExpression: DATE,
    components: "DATE_FLOOR_COMPONENTS"
  },
  EXP_ADDITION_DATE: {
    messageKey: "EXP_ADDITION_DATE",
    type: "Date Addition",
    dataType: "Date",
    components: "DATE_ADDITION_COMPONENTS"
  },
  EXP_SUBTRACTION_DATE: {
    messageKey: "EXP_SUBTRACTION_DATE",
    type: "Date Subtraction",
    dataType: "Date",
    components: "DATE_SUBTRACTION_COMPONENTS"
  },
  EXP_COUNT_UNIQUE: {
    messageKey: "EXP_COUNT_UNIQUE",
    type: "Count Unique",
    dataType: "Number",
    comparables: COMPARABLE_LIST, // don't include boolean
    components: "COUNT_UNIQUE_COMPONENTS"
  },
  EXP_ROUND_NUM: {
    messageKey: "EXP_ROUND_NUM",
    type: "Round Number",
    dataType: "Number",
    subExpression: NUMBER,
    components: "ROUND_COMPONENTS"
  },
  EXP_MULTIPLY_NUM: {
    messageKey: "EXP_MULTIPLY_NUM",
    type: "Multiply Number",
    dataType: "Number",
    subExpression: NUMBER,
    components: "MATH_MULTIPLICATION_COMPONENTS"
  },
  EXP_ADD_NUM: {
    messageKey: "EXP_ADD_NUM",
    type: "Add Number",
    dataType: "Number",
    subExpression: NUMBER,
    components: "MATH_ADDITION_COMPONENTS"
  },
  EXP_SUBTRACT_NUM: {
    messageKey: "EXP_SUBTRACT_NUM",
    type: "Subtract Number",
    dataType: "Number",
    subExpression: NUMBER,
    components: "MATH_SUBTRACTION_COMPONENTS"
  },
  EXP_ALL: {
    messageKey: "EXP_ALL",
    type: "All",
    dataType: "Bool",
    subExpression: BOOL_LIST,
    components: "ALL_EXP_COMPONENTS"
  },
  EXP_ANY: {
    messageKey: "EXP_ANY",
    type: "Any",
    dataType: "Bool",
    subExpression: BOOL_LIST,
    components: "ANY_EXP_COMPONENTS"
  },
  EXP_DIVIDE_NUM: {
    messageKey: "EXP_DIVIDE_NUM",
    type: "Divide Number",
    dataType: "Number",
    subExpression: NUMBER,
    components: "MATH_DIVISION_COMPONENTS"
  },
  EXP_SUM: {
    messageKey: "EXP_SUM",
    type: "Sum",
    dataType: "Number",
    subExpression: NUMBER_LIST,
    components: "SUM_COMPONENTS"
  },
  EXP_PRODUCT: {
    messageKey: "EXP_PRODUCT",
    type: "Product",
    dataType: "Number",
    subExpression: NUMBER_LIST,
    components: "PRODUCT_COMPONENTS"
  },
  isNull: {
    messageKey: "isNull",
    type: "Is Null",
    dataType: "Bool"
  },
  isNotNull: {
    messageKey: "isNotNull",
    type: "Is Not Null",
    dataType: "Bool"
  },
  EXP_CHALLENGE_REASONS: {
    messageKey: "challengeReasons",
    type: "Challenge Reasons",
    dataType: "String",
    subExpression: STRING,
    components: "CHALLENGE_REASONS_COMPONENTS"
  },
  EXP_TARGET_CHALLENGE_REASONS: {
    messageKey: "targetChallengeReasons",
    type: "Target Challenge Reasons",
    dataType: "String",
    subExpressions: STRING,
    components: "TARGET_CHALLENGE_REASONS_COMPONENTS"
  }
  // add other expressions here
};

export { LIST_COMPONENTS, EXPRESSIONS_TYPE };
